import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import LoadingScreen from "@/components/LoadingScreen";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Location from "@/pages/Location";
import Pricing from "@/pages/Pricing";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/location" element={<Location />} />
        <Route path="/preise" element={<Pricing />} />
        <Route path="/galerie" element={<Gallery />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <div className="bg-[#141414] min-h-screen text-[#F2EDE8]">
      <AnimatePresence>
        {loading && <LoadingScreen key="loader" onComplete={() => setLoading(false)} />}
      </AnimatePresence>
      {!loading && (
        <BrowserRouter>
          <Navbar />
          <AppRoutes />
          <Footer />
          <Toaster
            theme="dark"
            toastOptions={{
              style: {
                background: "#1C1C1E",
                border: "1px solid rgba(193, 68, 14, 0.4)",
                color: "#F2EDE8",
              },
            }}
          />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
